import { useTheme } from '@mui/system';
import { FC } from 'react';

import styles from './StatusCell.module.scss';

export type Statuses =
  | 'Created'
  | 'created'
  | 'Review'
  | 'review'
  | 'Pending'
  | 'Failed'
  | 'failed'
  | 'Succeed'
  | 'succeed'
  | 'success'
  | 'Approved'
  | 'Rejected'
  | 'rejected'
  | 'Payout'
  | 'payout'
  | 'In Process'
  | 'Need Approve'
  | 'Cancel'
  | 'cancel';

interface StatusCellProps {
  status: Statuses;
}

export const StatusCell: FC<StatusCellProps> = ({ status }) => {
  const { palette } = useTheme();

  const getStatusColor = () => {
    switch (true) {
      case ['succeed', 'success', 'approved', 'payout'].includes(status.toLowerCase()):
        return palette.success[palette.mode];

      case ['failed', 'rejected', 'cancel'].includes(status.toLowerCase()):
        return palette.error[palette.mode];

      default:
        return palette.warning[palette.mode];
    }
  };

  const color = getStatusColor();

  return <div className={styles.statusCircle} style={{ borderColor: color }}></div>;
};
